import React, { useState, useEffect, useCallback } from 'react';
import AgentList from '../components/AgentList';
import { GetAgentList } from '../../../api/order';
import Permission from '../components/Permission';
import { AclKeys } from '../utils/permissions';

const initParams = {
    Limit: 200,
    Offset: 0
}

function List(){

    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [companyList, setCompanyList] = useState([])

    useEffect(() => {
        getAgentList(initParams)
    }, [])

    const getAgentList = useCallback((data) => {
        setLoading(true)
        GetAgentList(data).then(res => {
            const { Data } = res;
            setCompanyList(Data || [])
            setLoading(false)
        }).catch((err) => {
            setErrorMessage(err.message)
            setLoading(false)
        })
    }, [])

    const handleAction = (item) => {
        window.location.href = `/usms/agentUserlist?AgentId=${item.Id}&AgentName=${item.AgentName}`
    }

    return <>
        <Permission aclKey={AclKeys.AllUserManage}>
            <AgentList
                loading={loading}
                errorMessage={errorMessage}
                companyList={companyList} 
                handleAction={handleAction}
            />
        </Permission>
    </>
}

export default List;